import React from 'react';
import { Section } from './Section';
import { Button } from './Button';
import { ShieldCheck, Zap } from 'lucide-react';
export function FinalOfferSection() {
  return <Section id="offer" className="bg-sage pb-24" data-id="element-24">
      <div className="bg-white rounded-3xl p-8 md:p-12 shadow-2xl border-2 border-gold max-w-3xl mx-auto text-center relative overflow-hidden" data-id="element-25">
        <div className="absolute top-0 right-0 w-32 h-32 bg-gold opacity-10 rounded-bl-full" data-id="element-26"></div>
        <div className="absolute bottom-0 left-0 w-32 h-32 bg-forest opacity-5 rounded-tr-full" data-id="element-27"></div>

        <h2 className="font-serif text-3xl md:text-4xl text-forest font-bold mb-6 relative z-10" data-id="element-28">
          Recupera tu confianza y el control de tu cuerpo hoy mismo.
        </h2>
        <p className="text-gray-600 text-lg mb-8 relative z-10" data-id="element-29">
          No esperes a que la hinchazón se convierta en un problema mayor.
        </p>

        <div className="bg-cream p-6 rounded-2xl mb-8 border border-sage-dark relative z-10" data-id="element-30">
          <p className="text-forest font-medium mb-3" data-id="element-31">
            Obtén el Protocolo Anti-Inflamación 72h por solo
          </p>
          <div className="inline-block bg-red-500 text-white font-bold text-sm md:text-base px-4 py-1.5 rounded-full mb-4 animate-pulse shadow-md" data-id="element-32">
            🔥 DESCUENTO DEL 68% — OFERTA LIMITADA
          </div>
          <div className="flex items-center justify-center gap-3 mb-2" data-id="element-33">
            <span className="text-2xl md:text-3xl text-gray-400 line-through font-serif" data-id="element-34">
              $19.99
            </span>
          </div>
          <div className="text-5xl md:text-6xl font-bold text-forest font-serif mb-2" data-id="element-35">
            $6.39 <span className="text-2xl text-gray-500" data-id="element-36">USD</span>
          </div>
          <p className="text-green-600 font-semibold text-sm" data-id="element-37">
            ¡Te ahorras $13.60 hoy!
          </p>
        </div>

        <Button className="w-full md:w-auto text-xl py-5 px-10 mb-6 relative z-10" data-id="element-38">
          ¡SÍ, QUIERO DESINFLAMARME AHORA!
        </Button>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-8 text-sm text-gray-500 relative z-10" data-id="element-39">
          <div className="flex items-center gap-2" data-id="element-40">
            <Zap className="w-5 h-5 text-gold" data-id="element-41" />
            <span data-id="element-42">Acceso inmediato tras la compra</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-43">
            <ShieldCheck className="w-5 h-5 text-green-600" data-id="element-44" />
            <span data-id="element-45">Pago seguro y encriptado</span>
          </div>
        </div>
      </div>
    </Section>;
}